export const environment = {
    prod: false,
    api_base_url: 'https://passlink-gcp.dev.int.bayer.com/api/'
};
